module.exports = __webpack_public_path__ + "static/media/12_Dalen - Dimman_eq 05-14.5badcd99.mp3";